module.exports = __webpack_public_path__ + "static/img/chaoshi1.70014b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/chaoshi1.png
// module id = l3V2
// module chunks = 0